
(function () {
  "use strict";

  // Lunar New Year dates, format YYYY: MMDD
  const lunarNewYear = {
    1940:208,1941:127,1942:215,1943:205,
    1944:125,1945:213,1946:202,1947:122,
    1948:210,1949:129,1950:217,1951:206,
    1952:127,1953:214,1954:203,1955:124,
    1956:212,1957:131,1958:218,1959:208,
    1960:128,1961:215,1962:205,1963:125,
    1964:213,1965:202,1966:121,1967:209,
    1968:130,1969:217,1970:206,1971:127,
    1972:215,1973:203,1974:123,1975:211,
    1976:131,1977:218,1978:207,1979:128,
    1980:216,1981:205,1982:125,1983:213,
    1984:202,1985:121,1986:209,1987:129,
    1988:217,1989:206,1990:127,1991:215,
    1992:204,1993:123,1994:210,1995:131,
    1996:219,1997:207,1998:128,1999:216,
    2000:205,2001:124,2002:212,2003:201,
    2004:122,2005:209,2006:129,2007:217,
    2008:207,2009:126,2010:214,2011:203,
    2012:123,2013:210,2014:131,2015:219,
    2016:208,2017:128,2018:216,2019:205,
    2020:125,2021:212,2022:201,2023:122,
    2024:210,2025:129,2026:217,2027:206,
    2028:126,2029:213,2030:203
  };

  // Traditional 60-year nap am cycle
  const napAm = [
    "Metal","Fire","Wood","Earth","Metal",
    "Fire","Water","Earth","Metal","Wood",
    "Water","Earth","Fire","Wood","Water",
    "Metal","Fire","Wood","Earth","Metal",
    "Fire","Water","Earth","Metal","Wood",
    "Water","Earth","Fire","Wood","Water"
  ];

  function initialize(root) {
    if (root.dataset.myeInitialized === "true") {
      return;
    }

    const form = root.querySelector(".mye-form");
    const input = root.querySelector('input[type="date"]');
    const error = root.querySelector(".mye-error");

    if (!form || !input || !error) return;

    root.dataset.myeInitialized = "true";

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      error.hidden = true;

      function showError(message) {
        error.textContent = message;
        error.hidden = false;
      }

      const match =
        /^(\d{4})-(\d{2})-(\d{2})$/.exec(input.value);

      if (!match) {
        showError("Please enter your date of birth.");
        return;
      }

      const year = Number(match[1]);
      const month = Number(match[2]);
      const day = Number(match[3]);

      const date = new Date(
        Date.UTC(year, month - 1, day)
      );

      if (
        year < 1940 ||
        year > 2030 ||
        date.getUTCFullYear() !== year ||
        date.getUTCMonth() !== month - 1 ||
        date.getUTCDate() !== day
      ) {
        showError(
          "Please enter a valid date between 1940 and 2030."
        );
        return;
      }

      // Find lunar birth year
      const birthMMDD = month * 100 + day;

      const lunarYear =
        birthMMDD < lunarNewYear[year]
          ? year - 1
          : year;

      // Determine the element
      const cycle =
        ((lunarYear - 1924) % 60 + 60) % 60;

      const element =
        napAm[Math.floor(cycle / 2)];

      
    // Redirect to the corresponding Five Elements result page
    const elementPages = {
      Wood: "/pages/your-element-wood",
      Fire: "/pages/your-element-fire",
      Earth: "/pages/your-element-earth",
      Metal: "/pages/your-element-metal",
      Water: "/pages/your-element-water"
    };

    const resultPage = elementPages[element];

    if (!resultPage) {
      showError("Unable to determine your element.");
      return;
    }

    
const birthday = input.value;
sessionStorage.setItem("fengShuiBirthday", birthday);

window.location.assign(resultPage);

  });
}

function initializeAll(scope) {

    if (
      scope.matches &&
      scope.matches(".mye-widget")
    ) {
      initialize(scope);
    }

    scope
      .querySelectorAll(".mye-widget")
      .forEach(initialize);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        initializeAll(document);
      }
    );
  } else {
    initializeAll(document);
  }

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      initializeAll(event.target);
    }
  );
})();
